// extracted by mini-css-extract-plugin
export var acitonButtons = "_mh-0";
export var additionalIcon = "_mh-f";
export var block = "_mh-1";
export var blockContent = "_mh-7";
export var blockDescription = "_mh-8";
export var blockIcon = "_mh-9";
export var blockTitle = "_mh-6";
export var border = "_mh-a";
export var center = "_mh-l";
export var edge = "_mh-b";
export var edgeLabel = "_mh-c";
export var edgePath = "_mh-d";
export var error = "_mh-e";
export var flowchart = "_mh-g";
export var flowchartContent = "_mh-h";
export var highlighted = "_mh-3";
export var hover = "_mh-4";
export var icon = "_mh-i";
export var left = "_mh-m";
export var navButton = "_mh-j";
export var navButtons = "_mh-k";
export var right = "_mh-n";
export var selected = "_mh-2";
export var small = "_mh-5";